import { UpsertTournamentApplicationUserDto } from 'modules/players/domain/interfaces/upsert-player-input.dto';

export function buildTournamentApplicationUserDto(params: {
  name: string;
  surname: string;
  birthDate: string;
  middleName?: string;
  height?: number;
  weight?: number;
  userId?: number;
}): UpsertTournamentApplicationUserDto {
  const { name, surname, birthDate, middleName, height, weight, userId } = params;
  return {
    name,
    surname,
    birthDate,
    ...(middleName ? { middleName } : {}),
    ...(height !== undefined ? { height } : {}),
    ...(weight !== undefined ? { weight } : {}),
    ...(userId ? { userId } : {}),
  };
}
